export default __webpack_public_path__ + "static/media/bg02.6ce4140b.jpg";